import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp7-new-headmaster-for-hogwarts",
  name: `The Daily Prophet\n'New Headmaster for Hogwarts'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'New Headmaster for Hogwarts'",
  },
  origin: "Harry Potter and the Deathly Hallows",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
